import { Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import { Check, ClipboardCopy } from "lucide-react";
import { useState } from "react";
import { ROUTES } from "../../../../config/routes";

export function ResumeLinkBanner({ applicationId }: { applicationId: string }) {
  const [copied, setCopied] = useState(false);
  const resumeUrl = `${window.location.origin}${ROUTES.PUBLIC.ONBOARD}?id=${applicationId}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(resumeUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = resumeUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Box
      borderRadius="lg"
      borderWidth="1px"
      borderColor="palomma.200"
      bg="palomma.50"
      p={4}
    >
      <Flex
        flexDirection={{ base: "column", sm: "row" }}
        alignItems={{ sm: "center" }}
        gap={3}
      >
        <Box flex="1" spaceY={1} minW={0}>
          <Text fontSize="sm" fontWeight="medium" color="gray.900">
            Guarda este enlace
          </Text>
          <Text fontSize="xs" color="gray.500" lineHeight="tall">
            Úsalo para continuar tu solicitud más adelante o revisar el estado.
            Si no lo tienes, contacta a Palomma.
          </Text>
        </Box>
        <Button
          variant="outline"
          colorPalette="palomma"
          size="sm"
          onClick={copyLink}
          flexShrink={0}
        >
          {copied ? (
            <HStack gap={1}>
              <Check size={16} /> Copiado
            </HStack>
          ) : (
            <HStack gap={1}>
              <ClipboardCopy size={16} /> Copiar enlace
            </HStack>
          )}
        </Button>
      </Flex>
    </Box>
  );
}
